import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip,
  MenuItem,
  Menu,
  Stack, Button, Divider,
  InputBase
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit, Delete, ArrowDropDown, Search } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import moment from 'moment/moment';
import { useDispatch } from 'react-redux';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import CatPagination from '../reusable/catPagination/CatPagination';
import { useNavigate } from 'react-router-dom';
import Operations from '../reusable/Operations';
import { deleteCategoriesThunk, setEditCategory } from '../../redux/category/getAllCategorySlice';
import { Filter } from '../../Svg';
import { fomateDate } from '../../utils/fomateDate';
import DateSortMenu from '../reusable/DateSortMenu';
import CalendarComp from '../reusable/calendar/CalendarComp';
import Calendar from 'react-calendar/dist/cjs/Calendar.js';
import '../reusable/calendar/calendar.css'
import { deletebomThunk } from '../../redux/bomSlice';
import { deletewizardThunk } from '../../redux/wizardSlice';

// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  borderBottom: '1px solid #E6E1E5',
  padding: '4px 40px',
  fontSize: '14px',
  color: '#667085',
}));

const SearchInput = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  width: '320px',
  fontFamily: `'Public Sans', sans-serif`,
}));
const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '6px 0px 0px 20px',
  fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingLeft: '6px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const New = styled(Chip)(({ theme }) => ({
  backgroundColor: '#4A4C561A',
  color: '#4A4C56',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Processing = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: '#F86624',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Quoted = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: '#F86624',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Delivered = styled(Chip)(({ theme }) => ({
  backgroundColor: '#E9FAF7',
  color: '#1A9882',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));





const AllBomEnqTable = ({ bomData, page, setPage, itemsPerPage, start, end, totalItems, selectedTab, enquiryType, handleDeleteClick, deleteCategory, isModalOpen, setIsModalOpen, path, onSort, onStatusFilter, sortBy, order, dateOrder, onDateSort, statusOrder, onStatusSort, statusFilterOptions, statusFilterValue, onStatusFilterChange }) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeColumn, setActiveColumn] = useState(null);

  const dispatch = useDispatch()
  const navigate = useNavigate()


  const handleOpenMenu = (event, column) => {
    if (enquiryType !== 'Wizard') return;
    setAnchorEl(event.currentTarget);
    setActiveColumn(column);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setActiveColumn(null);
  };

  const handleSort = (direction) => {
    onSort?.(activeColumn, direction);
    handleCloseMenu();
  };

  const handleStatusFilter = (status) => {
    onStatusFilter?.(status);
    handleCloseMenu();
  };

  const isWizardEnquiry = enquiryType === 'Wizard';
  const getFilterHeaderProps = (column) => isWizardEnquiry ? {
    onClick: (event) => handleOpenMenu(event, column),
    sx: { cursor: 'pointer' },
  } : {};

 
  return (
    <>

      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <HeaderCell {...getFilterHeaderProps('enquiryId')}>
                Enquiry ID
                <IconButton aria-label="Filter enquiry ID" onClick={(event) => { event.stopPropagation(); handleOpenMenu(event, 'enquiryId'); }}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell {...getFilterHeaderProps('user.companyName')}>
                Customer
                <IconButton aria-label="Filter customer" onClick={(event) => { event.stopPropagation(); handleOpenMenu(event, 'user.companyName'); }}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell {...getFilterHeaderProps('productCount')}>
                Products
                <IconButton aria-label="Filter products" onClick={(event) => { event.stopPropagation(); handleOpenMenu(event, 'productCount'); }}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell {...getFilterHeaderProps('createdAt')}>
                Date
                {onDateSort ?
                  <DateSortMenu order={dateOrder} onChange={onDateSort} ariaLabel="Sort by date" />
                  :
                  <IconButton aria-label="Filter date" onClick={(event) => { event.stopPropagation(); handleOpenMenu(event, 'createdAt'); }}>
                    <ArrowDropDown />
                  </IconButton>
                }
              </HeaderCell>


              {/* <HeaderCell>
                Total
                <IconButton aria-label="Filter enquiry type" onClick={(e) => handleOpenMenu(e, 'type')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell> */}

              <HeaderCell {...getFilterHeaderProps('type')}>
                Enquiry Type
                <IconButton aria-label="Filter enquiry type" onClick={(event) => { event.stopPropagation(); handleOpenMenu(event, 'type'); }}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell {...getFilterHeaderProps('status')}>
                Status
                {onStatusSort ?
                  <DateSortMenu order={statusOrder} onChange={onStatusSort} ariaLabel="Filter or sort by status" statusOptions={statusFilterOptions} statusValue={statusFilterValue} onStatusChange={onStatusFilterChange} />
                  :
                  <IconButton aria-label="Filter status" onClick={(event) => { event.stopPropagation(); handleOpenMenu(event, 'status'); }}>
                    <ArrowDropDown />
                  </IconButton>
                }
              </HeaderCell>

              <HeaderCell>
                Action
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {bomData?.map((row) => (
              <TableRow key={row._id}>

                <ProductText sx={{ width: '13%' }}>{row?.enquiryId}</ProductText>

                <TableCells sx={{
                  width: '14%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* <div>
                      {
                        row?.thumbnail?.photo ? <img src={row?.thumbnail?.photo} style={{ width: 44, height: 44, borderRadius: 2 }} /> : <img src="/assets/profile.png" />
                      }
                    </div> */}
                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{row?.user?.companyName}</strong>
                      <div style={{ fontSize: '12px', color: '#667085', fontWeight: '500', }}>
                        {row?.user?.fullName}
                      </div>
                    </div>
                  </div>
                </TableCells>

                <ProductText sx={{ width: '12%' }}>{row?.productCount}</ProductText>


                {/* <TableCells sx={{
                  width: '10%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{row.name}</strong>
                      <div style={{ fontSize: '12px', color: '#667085', fontWeight: '500', }}>
                        {row.description}
                      </div>
                    </div>
                  </div>
                </TableCells> */}

                <TableCells sx={{ width: '12%', fontSize: '12px', color: '#667085', fontWeight: '500' }}>
                  {fomateDate(row.createdAt)}
                </TableCells>

                {/* <TableCells sx={{ width: '14%', fontSize: '12px', color: '#667085', fontWeight: '500' }}>
                  {row?.total}
                </TableCells> */}
                <TableCells sx={{ width: '14%', fontSize: '12px', color: '#667085', fontWeight: '500' }}>
                  {enquiryType}
                </TableCells>


                <TableCells sx={{ width: '11%' }}>
                  {row?.status === "NEW" ? (
                    <New label="New" size="small" />
                  ) : row?.status === "QUOTED" ? (
                    <Quoted label="Quoted" size="small" />
                  ) :  (
                    <Delivered label="Completed" size="small" />
                  )}
                </TableCells>


                <Operations sx={{ width: '8% !important' }}
                  TableCells={TableCells}
                  viewClick={() => navigate(`${path}/${row?.enquiryId}`)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                  selectedTab={1}
                  hidedelete={selectedTab == 4 && 'hide'}
                />

                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'bom'}
                  onClose={() => setIsModalOpen(false)}
                  onDelete={deleteCategory}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {isWizardEnquiry && (
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
          >
            {activeColumn === 'status' && selectedTab === 0 && (
              <>
                <MenuItem onClick={() => handleStatusFilter('')}>All statuses</MenuItem>
                <MenuItem onClick={() => handleStatusFilter('NEW')}>New</MenuItem>
                <MenuItem onClick={() => handleStatusFilter('QUOTED')}>Quoted</MenuItem>
                <MenuItem onClick={() => handleStatusFilter('COMPLETED')}>Completed</MenuItem>
                <Divider />
              </>
            )}
            <MenuItem onClick={() => handleSort('asc')}>
              Sort ascending{sortBy === activeColumn && order === 'asc' ? ' ✓' : ''}
            </MenuItem>
            <MenuItem onClick={() => handleSort('desc')}>
              Sort descending{sortBy === activeColumn && order === 'desc' ? ' ✓' : ''}
            </MenuItem>
          </Menu>
        )}
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />
        </div>
      </TableContainerStyled>

    </>
  );
};

export default AllBomEnqTable;
